// extracted by mini-css-extract-plugin
module.exports = {"collapseHeader":"_1ByIwHx-","borderTop":"tKz1fQGP"};